var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-tab_wrapper"},_vm._l((_vm.tabList),function(tab){return _c('div',{key:tab.id,staticClass:"c-tab_wrapper-items",class:{'c-tab_wrapper-itemsActive': tab.id===_vm.nowId},on:{"click":function($event){return _vm.tabClik(tab)}}},[_vm._v("\n     "+_vm._s(tab.name)+"\n  ")])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-81f55a2e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/cashier/components/c-query-table/c-table-tab.vue
// module id = null
// module chunks = 